<page-content [fullPageWidth]="true">
    <header-elitment header [hasSideMenu]="true"></header-elitment>
    <side-menu left-menu>
        <athlete-side-menu></athlete-side-menu>
    </side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!is401 && !is404" title="{{ 'feedback'|translate }}">
        <ng-template #questionComponentRef></ng-template>
    </module-content>

</page-content>
